<template>
  <el-container v-title data-title="教职员考勤周报表" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>考勤管理</el-breadcrumb-item>
                <el-breadcrumb-item>教职员考勤周报表</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form :inline="true" :model="searchForm" class="demo-form-inline" >
                <el-form-item label="学校">
                  <el-select v-model="searchForm.schoolId" filterable>
                    <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="教职员类型">
                  <el-select v-model="searchForm.facultyType" placeholder="类型">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="老师" value="1"></el-option>
                    <el-option label="教职工" value="2"></el-option>
                    <el-option label="其他" value="3"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="报表类型">
                  <el-select v-model="searchForm.statsType" placeholder="类型">
                    <el-option label="日报表" value="day"></el-option>
                    <el-option label="周报表" value="week"></el-option>
                    <el-option label="月报表" value="month"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="searchForm.statsType == 'day'" label="日">
                  <el-date-picker
                    v-model="firstDay"
                    align="right"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions">
                  </el-date-picker>
                </el-form-item>
                <el-form-item v-if="searchForm.statsType == 'week'" label="周">
                  <el-date-picker
                    v-model="weekFirstDay"
                    type="week"
                    format="yyyy 年第 WW 周"
                    placeholder="选择周"
                    :picker-options="{'firstDayOfWeek': 1}">
                  </el-date-picker>
                </el-form-item>
                <el-form-item v-if="searchForm.statsType == 'month'" label="月">
                  <el-date-picker
                    v-model="month"
                    type="month"
                    placeholder="选择月"
                    value-format="yyyy-MM">
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" :loading="isSearching" @click="statFacultyAttendanceByWeek">查询</el-button>
                  <el-button type="primary" :loading="isDownloading" @click="downloadStatFacultyAttendanceByWeek">下载</el-button>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
        <el-tabs v-model="activeTab" type="card">
          <el-tab-pane label="考勤记录" name="tab1">
            <el-table v-loading="loading" :data="tableData" border stripe height="960">
              <el-table-column v-for="(title, index) in tableTitleList1" :key="index" :prop="title" :label="title" :width="title == '姓名' ? 85 : 170">
                <template slot-scope="scope">
                  <span v-if="title == '姓名'">{{scope.row[title]}}</span>
                  <div v-if="title != '姓名'">
                    <div v-for="(dataObject, index) in scope.row[title]" :key="index">
                      {{ scope.row[title][index]['time'] }} | {{ scope.row[title][index]['direct'] }} | {{ scope.row[title][index]['deviceName'] }} | {{ scope.row[title][index]['remarkOfInOut'] }} | {{ scope.row[title][index]['remarkOfAbnormal'] }} | {{ scope.row[title][index]['remarkOfLateAndLeaveEarlyAndGoOut'] }}
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="迟到早退记录" name="tab2">
            <el-table v-loading="loading" :data="tableData" border stripe height="960">
              <el-table-column v-for="(title, index) in tableTitleList2" :key="index" :prop="title" :label="title" :width="title == '姓名' || title == '迟到早退次数'? 85 : 170">
                <template slot-scope="scope">
                  <span v-if="title == '姓名'">{{scope.row[title]}}</span>
                  <span v-if="title == '迟到早退次数'">{{scope.row[title]}}</span>
                  <div v-if="title != '姓名' && title != '迟到早退次数'">
                    <div v-for="(dataObject, index) in scope.row[title]" :key="index">
                      <span v-if="scope.row[title][index]['remarkOfLateAndLeaveEarlyAndGoOut'].includes('迟到') || scope.row[title][index]['remarkOfLateAndLeaveEarlyAndGoOut'].includes('早退')">
                        {{ scope.row[title][index]['time'] }} | {{ scope.row[title][index]['direct'] }} | {{ scope.row[title][index]['deviceName'] }} | {{ scope.row[title][index]['remarkOfInOut'] }} | {{ scope.row[title][index]['remarkOfAbnormal'] }} | {{ scope.row[title][index]['remarkOfLateAndLeaveEarlyAndGoOut'] }}
                      </span>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="外出记录" name="tab3">
            <el-table v-loading="loading" :data="tableData" border stripe height="960">
              <el-table-column v-for="(title, index) in tableTitleList3" :key="index" :prop="title" :label="title" :width="title == '姓名' || title == '外出次数' ? 85 : 170">
                <template slot-scope="scope">
                  <span v-if="title == '姓名'">{{scope.row[title]}}</span>
                  <span v-if="title == '外出次数'">{{scope.row[title]}}</span>
                  <div v-if="title != '姓名' && title != '外出次数'">
                    <div v-for="(dataObject, index) in scope.row[title]" :key="index">
                      <span v-if="scope.row[title][index]['remarkOfLateAndLeaveEarlyAndGoOut'].includes('外出')">
                        {{ scope.row[title][index]['time'] }} | {{ scope.row[title][index]['direct'] }} | {{ scope.row[title][index]['deviceName'] }} | {{ scope.row[title][index]['remarkOfInOut'] }} | {{ scope.row[title][index]['remarkOfAbnormal'] }} | {{ scope.row[title][index]['remarkOfLateAndLeaveEarlyAndGoOut'] }}
                      </span>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      schoolList: [],
      schoolInfo: {},
      weekFirstDay: '',
      firstDay: '',
      month: '',
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      tableData: [],
      tableTitleList1: ['姓名'],
      tableTitleList2: ['姓名'],
      tableTitleList3: ['姓名'],
      loading: false,
      searchForm: {
        schoolId: null,
        facultyType: '',
        statsType: 'week'
      },
      isSearching: false,
      isDownloading: false,
      activeTab: 'tab1'
    }
  },
  created () {
    let now = Math.round(new Date().getTime() / 1000)
    if (this.Cookie.get('offsetSecond') !== undefined || this.Cookie.get('offsetSecond') !== '') {
      now += parseInt(this.Cookie.get('offsetSecond'))
      let calcMonday = new Date(now * 1000)
      let day = calcMonday.getDay() || 7
      if (day !== 1) {
        calcMonday.setHours(-24 * (day - 1))
      }
      calcMonday.setHours(8)
      this.weekFirstDay = calcMonday.toISOString().slice(0, 10)
      let calcToday = new Date(now * 1000)
      calcToday.setHours(8)
      this.firstDay = calcToday.toISOString().slice(0, 10)
      this.month = calcToday.toISOString().slice(0, 7)
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      this.getSchoolList()
    }
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    handleClose (done) {
      done()
    },
    getSchoolList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/school/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id,
          id: 32
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.schoolList = res.data.data.list
            if (_this.schoolList.length > 0) {
              _this.searchForm.schoolId = _this.schoolList[0].id
              _this.statFacultyAttendanceByWeek()
            }
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    statFacultyAttendanceByWeek () {
      if (this.month === '') return
      let _this = this
      let firstDayStr = ''
      let days = 0
      if (_this.searchForm.statsType === 'day') {
        firstDayStr = _this.firstDay
        days = 1
      } else if (_this.searchForm.statsType === 'week') {
        firstDayStr = _this.weekFirstDay
        days = 7
      } else if (_this.searchForm.statsType === 'month') {
        firstDayStr = _this.month + '-01'
        days = new Date(firstDayStr.substring(0, 4), firstDayStr.substring(5, 7), 0).getDate()
      } else {
        return
      }
      _this.tableTitleList1 = ['姓名']
      _this.tableTitleList2 = ['姓名']
      _this.tableTitleList3 = ['姓名']
      _this.tableData = []
      _this.loading = true
      _this.isSearching = true
      this.$axios.post(this.GLOBAL.host + '/attendence/statFacultyAttendanceForNingweiMiddleSchool',
        this.$qs.stringify({
          schoolId: _this.searchForm.schoolId,
          facultyType: _this.searchForm.facultyType,
          firstDayStr: firstDayStr,
          days: days
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            if (res.data.data != null && res.data.data.length > 0) {
              _this.tableTitleList1 = []
              _this.tableTitleList2 = []
              _this.tableTitleList3 = []
              _this.schoolList.forEach(school => {
                if (_this.searchForm.schoolId != null && _this.searchForm.schoolId === school.id) {
                  _this.schoolInfo = school
                }
              })
              Object.keys(res.data.data[0]).forEach((key) => {
                console.log('key: ' + key)
                if (key !== 'userId' && key !== '迟到早退次数' && key !== '外出次数') {
                  _this.tableTitleList1.push(key)
                }
                if (key !== 'userId' && key !== '外出次数') {
                  _this.tableTitleList2.push(key)
                }
                if (key !== 'userId' && key !== '迟到早退次数') {
                  _this.tableTitleList3.push(key)
                }
              })
              _this.tableData = res.data.data
            }
          } else {
            this.$message.error(res.data.message)
          }
        }
        _this.loading = false
        _this.isSearching = false
      })
    },
    downloadStatFacultyAttendanceByWeek () {
      if (this.month === '') return
      let _this = this
      let firstDayStr = ''
      let days = 0
      if (_this.searchForm.statsType === 'day') {
        firstDayStr = _this.firstDay
        days = 1
      } else if (_this.searchForm.statsType === 'week') {
        firstDayStr = _this.weekFirstDay
        days = 7
      } else if (_this.searchForm.statsType === 'month') {
        firstDayStr = _this.month + '-01'
        days = new Date(firstDayStr.substring(0, 4), firstDayStr.substring(5, 7), 0).getDate()
      } else {
        return
      }
      _this.isDownloading = true
      this.$axios.post(this.GLOBAL.host + '/attendence/downloadFacultyAttendanceForNingweiMiddleSchool', this.$qs.stringify({
        schoolId: _this.searchForm.schoolId,
        facultyType: _this.searchForm.facultyType,
        firstDayStr: firstDayStr,
        days: days
      }), {
        responseType: 'blob'
      }).then(res => {
        if (res.data != null) {
          let errorMessage = ''
          let reader = new FileReader()
          reader.onload = function () {
            try {
              let response = JSON.parse(reader.result)
              if (response != null && response.message != null) {
                errorMessage = response.message
                console.log('errorMessage-111111')
                console.log('errorMessage: ' + errorMessage)
                _this.$message.error(errorMessage)
              }
            } catch (e) {
              let contentDisposition = res.headers['content-disposition']
              console.log(contentDisposition)
              let fileName = window.decodeURI(contentDisposition.substring(contentDisposition.indexOf('=') + 1))
              let blob = new Blob([res.data], {type: 'application/vnd.ms-excel'})
              let url = window.URL.createObjectURL(blob)
              const link = document.createElement('a')
              link.href = url
              link.download = fileName // 重命名文件
              link.click()
              URL.revokeObjectURL(url) // 释放内存
            }
          }
          reader.readAsText(res.data)
        }
        _this.isDownloading = false
      })
    }
  }
})
</script>
<style>
  .grid-content {
    min-height: 25px;
    line-height: 25px;
    padding: 2px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/AttendenceStatsOfNingweiMiddleSchool.vue